import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { loyaltyService } from '../services';
import { setAstrapayBalance, setIsAstrapayConnected } from '../store/loyalty/action';
import { IRootState } from '../store';
import { ILoyaltyCustomer } from '../interface/customer.interfaces';
import { ILoyaltyInitialState } from '../store/loyalty/reducer';

const useGetBalanceAstrapay = () => {
  const dispatch = useDispatch();
  const { userData } = useSelector((state: IRootState) => state.auth);
  const { isAstrapayConnected, astrapayBalance }: ILoyaltyInitialState = useSelector(
    (state: IRootState) => state.loyalty
  );
  const [isFinishProcessData, setIsFinishProcessData] = useState<boolean>(false);

  useEffect(() => {
    if (userData && userData.astrapaySignature) {
      setIsFinishProcessData(false);
      loyaltyService
        .getBalanceAstrapay('desktop')
        .then((res) => {
          const notConnected = res as string;
          const connected = res as ILoyaltyCustomer;
          dispatch(
            setIsAstrapayConnected(
              notConnected !== 'Get balance failed' && Boolean(connected?.formatterValue)
            )
          );
          dispatch(setAstrapayBalance(connected));
          setIsFinishProcessData(true);
        })
        .catch(() => {
          dispatch(setIsAstrapayConnected(false));
          setIsFinishProcessData(true);
        });
    } else if (userData && !userData.astrapaySignature) {
      setIsFinishProcessData(true);
    }
  }, [userData, userData?.astrapayToken]);

  return {
    isAstrapayConnected: isAstrapayConnected && userData?.astrapayToken,
    astrapayBalance,
    isFinishProcessData,
  };
};

export default useGetBalanceAstrapay;
